import axios from "axios";
import React, { useState } from "react";
import BASE_API_URL from "../apis/index";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";

function FormRegisterRabiesEducation({ isMobile }) {
  const [sclName, setSclName] = useState("");
  const [sclAddr, setSclAddr] = useState("");
  const [sclEml, setSclEml] = useState("");
  const [sclNmbr, setSclNmbr] = useState("");
  const [consent, setConsent] = useState(false);
  const [showFullConsent, setShowFullConsent] = useState(false);
  const [formSbtMsg, setFormSbtMsg] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!consent) {
      setSuccess(false);
      setFormSbtMsg("Please accept the consent to continue.");
      return;
    }

    try {
      const response = await axios.post(
        `${BASE_API_URL}/user/school-register`,
        {
          sclName,
          sclAddr,
          sclEml,
          sclNmbr,
          // consent: true, // uncomment if your backend should store the consent
        },
      );

      if (response.data.Status === "OK") {
        setSuccess(true);
        setFormSbtMsg("School registered successfully!");
        // Clear the form fields
        setSclName("");
        setSclAddr("");
        setSclEml("");
        setSclNmbr("");
        setConsent(false);
        setShowFullConsent(false);
      } else {
        setSuccess(false);
        setFormSbtMsg("Something went wrong. Try again!");
      }
    } catch (err) {
      setSuccess(false);
      setFormSbtMsg("Something went wrong. Try again!");
    }
  };

  const linkStyle = {
    background: "none",
    border: "none",
    padding: 0,
    marginLeft: "6px",
    color: "#0d6efd",
    textDecoration: "underline",
    cursor: "pointer",
    fontSize: "12px",
    whiteSpace: "nowrap",
  };

  return (
    <form onSubmit={handleSubmit} className="emailForm">
      <div className="form-fields">
        <TextField
          required
          type="text"
          label="Your School Name"
          value={sclName}
          onChange={(e) => setSclName(e.target.value)}
          size="small"
          className={isMobile ? "w-100" : "w-33"}
        />
        <TextField
          required
          label="Your School Address"
          type="text"
          value={sclAddr}
          onChange={(e) => setSclAddr(e.target.value)}
          size="small"
          className={isMobile ? "w-100" : "w-33"}
        />
        <TextField
          required
          label="Email"
          type="email"
          value={sclEml}
          onChange={(e) => setSclEml(e.target.value)}
          size="small"
          className={isMobile ? "w-100" : "w-33"}
        />
        <TextField
          required
          label="Number"
          type="tel"
          value={sclNmbr}
          onChange={(e) => setSclNmbr(e.target.value)}
          size="small"
          className={isMobile ? "w-100" : "w-33"}
        />
      </div>

      {/* Consent */}
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginTop: "8px",
          width: "100%",
          maxWidth: isMobile ? "100%" : "66%", // keeps text clear of the child image
        }}
      >
        <Checkbox
          required
          size="small"
          checked={consent}
          onChange={(e) => setConsent(e.target.checked)}
          sx={{ p: 0, mr: 1, mt: "2px" }}
        />

        <div
          style={{
            flex: 1,
            minWidth: 0,
            fontSize: "14px",
            lineHeight: "1.5",
            color: "#333",
          }}
        >
          {!showFullConsent ? (
            // Collapsed: single line + Read more
            <div style={{ display: "flex", alignItems: "center" }}>
              <span
                style={{
                  flex: 1,
                  minWidth: 0,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                I voluntarily provide my consent to Indian Immunologicals
                Limited to collect, use and process my personal information...
              </span>
              <button
                type="button"
                style={linkStyle}
                onClick={() => setShowFullConsent(true)}
              >
                Read more
              </button>
            </div>
          ) : (
            // Expanded: full text + Show less
            <div
              style={{
                maxHeight: "50px",
                overflowY: "auto",
                fontSize: "14px",
                paddingRight: "4px",
              }}
            >
              <p style={{ marginBottom: "6px", fontSize: "14px" }}>
                I voluntarily provide my consent to Indian Immunologicals
                Limited to collect, use and process my personal information,
                such as my name, contact details and other information provided
                by me, for purposes including communication, participation in
                awareness or educational activities, events, feedback, and other
                related activities.
              </p>
              <p style={{ marginBottom: "6px", fontSize: "14px" }}>
                I understand that my personal information may be shared with
                authorised service providers or other relevant parties, where
                necessary, for carrying out these activities or to comply with
                applicable laws and regulations.
              </p>
              <p style={{ marginBottom: "6px", fontSize: "14px" }}>
                I understand that my data will be handled in accordance with
                applicable provisions of the Digital Personal Data Protection
                Act, 2023.
              </p>
              <p style={{ marginBottom: "6px", fontSize: "14px" }}>
                I understand that I may have rights in relation to my personal
                data as provided under applicable law.
                <button
                  type="button"
                  style={linkStyle}
                  onClick={() => setShowFullConsent(false)}
                >
                  Show less
                </button>
              </p>
            </div>
          )}
        </div>
      </div>

      {formSbtMsg && (
        <p className={success ? "text-success" : "text-danger"}>{formSbtMsg}</p>
      )}

      <button
        type="submit"
        disabled={!consent}
        className="px-4 py-2 text-white rounded border-0 bgSecondary bgHoverPrimary mt-2"
        style={{
          opacity: consent ? 1 : 0.6,
          cursor: consent ? "pointer" : "not-allowed",
        }}
      >
        Submit
      </button>
    </form>
  );
}

export default FormRegisterRabiesEducation;
